(() => {
	const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

	const shareProduct = async () => {
		consell.log("Clicked Share Button");
		if (!navigator.share) return;

		const title = document.querySelector(".product-single__title").innerText;
		await navigator.share({
			title: title,
			text: title, // Eventually this will have the elevator tag line
			url: location.href,
		});

		consell.log("Share Complete");
	};

	const addListeners = () => {
		const isIOS =
			/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		const isAndroid = /android/i.test(navigator.userAgent);
		const isMobile = isIOS || isAndroid;

		const shareBtns = [...document.querySelectorAll(".mobile-share-button")];
		shareBtns.forEach((s) => {
			if (!isMobile) {
				s.remove();
				return;
			}
			s.addEventListener("click", shareProduct);
		});
	};

	document.addEventListener("quick-view", async () => {
		consell.log("event");
		setTimeout(() => addListeners(), 1000);
	});

	const init = () => {
		addListeners();
	};
	init();
})();
